// @ts-nocheck
import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { darken } from "@material-ui/core";
import CartTotalBadge from "./CartTotalBadge";
import CartMenuContent from "./CartMenuContent";
import { usePayment } from "../../hooks/usePayment";
import Popper from "@material-ui/core/Popper";
import { useApp } from "../../../app/hooks/useApp";
import IconButton from "@material-ui/core/IconButton";
import FontIcon from "../../../../components/FontIcon";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Button from "../../../../components/Button";
import { AdapterLink } from "../../../../components/Adopter";
import CardContent from "@material-ui/core/CardContent";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
  menu: {
    width: 350,
    padding: 0,
    paddingBottom: theme.spacing(2),
  },
  icon: {
    "& .MuiIcon-root": {
      fontSize: 18,
    },
  },
  openIcon: {
    backgroundColor: "#eeeff3",
    color: "#858997",
    "&:hover": {
      backgroundColor: darken("#eeeff3", 0.1),
      color: "#858997",
    },
  },
  menuContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: 0,
    paddingBottom: 0,
  },
  actions: {
    justifyContent: "space-between",
    padding: theme.spacing(2),
    "&>a": {
      width: "50%",
    },
  },
  buttonIcon: {
    transform: "scale(-1)",
    fontSize: "10px!important",
  },
}));

const CartMenu: FC<ComponentProps<any>> = (props) => {
  const classes = useStyles();

  const {
    data: { isCartOpen },
    actions: { toggleCart, closeCart },
  } = useApp();

  const {
    data: { cart },
  } = usePayment();

  const cartAnchorRef = React.useRef(null);

  const showBadge = useMemo(() => {
    return !isCartOpen && cart.length > 0;
  }, [cart.length, isCartOpen]);

  const onOutsideClicked = useCallback(
    (e) => {
      if (cartAnchorRef.current !== e.currentTarget) {
        e.preventDefault();
        toggleCart();
      }
    },
    [cartAnchorRef],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  if (!cartAnchorRef) return null;

  return (
    <>
      <IconButton
        className={clsx(classes.icon, isCartOpen ? classes.openIcon : null)}
        ref={cartAnchorRef}
        onMouseUp={toggleCart}
      >
        <FontIcon name="shopping_cart" />
        <CartTotalBadge cart={cart} open={showBadge} />
      </IconButton>

      <Popper
        transition
        open={isCartOpen}
        disablePortal
        anchorEl={cartAnchorRef.current}
        placement={"bottom"}
      >
        <ClickAwayListener
          mouseEvent={"onMouseUp"}
          onClickAway={onOutsideClicked}
        >
          <Card className={classes.menu}>
            <CardContent className={classes.menuContent}>
              <CartMenuContent cart={cart} />
            </CardContent>
            <CardActions onClick={closeCart} className={classes.actions}>
              <Button
                component={AdapterLink}
                variant={"outlined"}
                to={"/cart"}
                endIcon={
                  <FontIcon name={"back"} className={classes.buttonIcon} />
                }
              >
                Cart
              </Button>
              <Button
                component={AdapterLink}
                variant={"contained"}
                color={"secondary"}
                to={"/checkout"}
                endIcon={
                  <FontIcon name={"back"} className={classes.buttonIcon} />
                }
              >
                Checkout
              </Button>
            </CardActions>
          </Card>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default React.memo(CartMenu);
